import React, { useCallback, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import { Row } from "react-bootstrap";
import classes from "./Chart.module.css";
import { KWHText } from "../Shared/Methods";
import { Link } from "react-scroll";
import ScrollToSectionButton from "../Components/ScrollToSpecificSection";
import CommonNodataFound from "../Components/CommonNodataFound";

export default function RadialBar({
  series,
  label,
  percentage,
  AvgConsumption,
  style,
  sethighlight,
}: {
  series: number;
  label: string;
  percentage: number;
  AvgConsumption: number;
  style?: any;
  sethighlight?: any;
}) {
  useEffect(() => {
    seriesdata();
  }, [series]);

  const seriesdata = useCallback(() => {
    return series;
  }, [series]);

  return (
    <>
      <Row>
        <div className={style}>
          {series?.toString() && (
            <ReactApexChart
              height={400}
              series={[percentage && series ? percentage : 0]}
              type="radialBar"
              options={{
                // noData: {
                //   text: "No Data Found",

                // },
                chart: {
                  type: "radialBar",
                  offsetY: -20,
                  sparkline: {
                    enabled: true,
                  },
                },
                plotOptions: {
                  radialBar: {
                    startAngle: -90,
                    endAngle: 90,
                    track: {
                      background: "#e7e7e7",
                      strokeWidth: "97%",
                      margin: 5, // margin is in pixels
                      dropShadow: {
                        enabled: true,
                        top: 2,
                        left: 0,
                        color: "#999",
                        opacity: 1,
                        blur: 2,
                      },
                    },
                    dataLabels: {
                      show: false,
                      name: {
                        show: false,
                      },
                      value: {
                        formatter: (val) => {
                          return series?.toString() ? series?.toString() : "0";
                        },
                        // color: "#111",
                        fontSize: "35px",
                        show: true,
                        fontWeight: 600,
                        offsetY: -10,
                      },
                    },
                  },
                },
                grid: {
                  padding: {
                    top: -10,
                  },
                },
                fill: {
                  type: "gradient",
                  gradient: {
                    shade: "light",
                    shadeIntensity: 0.4,
                    inverseColors: false,
                    opacityFrom: 1,
                    opacityTo: 1,
                    stops: [0, 50, 53, 91],
                  },
                },
                responsive: [
                  {
                    breakpoint: 1420,
                    options: {
                      chart: {
                        height: 300,
                      },
                    },
                  },
                  {
                    breakpoint: 1190,
                    options: {
                      chart: {
                        height: 250,
                      },
                    },
                  },
                  {
                    breakpoint: 1502,
                    options: {
                      chart: {
                        height: 350,
                      },
                    },
                  },
                  {
                    breakpoint: 1260,
                    options: {
                      chart: {
                        height: 270,
                      },
                    },
                  },
                  {
                    breakpoint: 992,
                    options: {
                      chart: {
                        height: 350,
                      },
                    },
                  },
                ],
                labels: [label],
                colors: ["#20A2A0"],
              }}
            />
          )}
        </div>
        {series?.toString() ? (
          <ScrollToSectionButton
            children={
              <div style={{ position: "relative" }}>
                <p
                  className={classes.KWH_text}
                  onClick={() =>
                    sethighlight({
                      ishighlight: true,
                    })
                  }
                >
                  <span
                    style={{ fontSize: "calc(2vh + 17px)", fontWeight: "600" }}
                  >
                    {series}
                  </span>
                  {KWHText}
                </p>
              </div>
            }
          />
        ) : (
          <p style={{ color: "rgb(55 61 63)" }}>No Data Found</p>
        )}
        {series?.toString() ? (
          <p style={{ fontSize: 10, textAlign: "center" }}>
            <span style={{ color: "red", fontSize: 15 }}>*</span>
            Average Consumption of Last Week :{" "}
            <strong style={{ fontSize: "13px" }}>{AvgConsumption}</strong>
            <span>{KWHText}</span>
          </p>
        ) : null}
      </Row>
    </>
  );
}
